import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@material';
import { StoreModule } from '@store';

// Import dependent modules
@NgModule({
    declarations: [
        // Shared components will be added here
        // Directives will be added here
        // Pipes will be added here
    ],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, StoreModule],
    exports: [
        // Re-export common Angular modules
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        // Re-export MaterialModule for convenience
        MaterialModule,

        // Export shared components, directives, pipes
        // These will be added during migration
    ],
})
export class SharedModule {}
